export const reduceEventDetails = (event) => {
  if (!event) return {};
  const {
    title,
    startStr,
    endStr,
    allDay = false,
    extendedProps: { weddingId, location, googleLocation, notes },
  } = event;
  return { title, weddingId, startStr, endStr, allDay, location, googleLocation, notes };
};
